export default {
	getFxRates({ state, commit }, currency = 'USD') {
		if (_.isEmpty(state.fxRates)) {
			axios
				.get('/api/fx-rates', {
					params: {
						currency,
					},
				})
				.then(({ data: { data } }) => {
					commit('SetFxRates', data.fx_rates)
				})
		}
	},
}
